const MF = 2;
const LN = 1;

export const DIP_MOVEMENTS = [
  { id: 1, label: "Default", locationId: [LN, MF] },
  { id: 2, label: "Foam Cup", locationId: LN },
  { id: 3, label: "3D Printed", locationId: LN },
  { id: 4, label: '9" Disks', locationId: LN },
  { id: 5, label: "Disks", locationId: LN },
  { id: 6, label: "3D Printed Disk", locationId: LN },
  { id: 7, label: "Impeller LH", locationId: LN },
  { id: 8, label: "Disks Lip Prewet", locationId: LN },
  { id: 9, label: '9" Disks Lip Prewet', locationId: LN },
  { id: 10, label: "3D Printed Disk Lip Prewet", locationId: LN },
  { id: 11, label: "Impeller RH", locationId: LN },
  { id: 12, label: "Transfer Dip", locationId: LN },
  { id: 13, label: "Victaulic", locationId: MF },
  { id: 14, label: "No Tilt", locationId: LN },
  { id: 15, label: "Heavy Part", locationId: LN },
  { id: 16, label: "Heavy Alt", locationId: LN },
  { id: 17, label: "Extra Drain", locationId: LN },
  { id: 18, label: "Dixon Socket", locationId: [LN, MF] },
  { id: 19, label: "Retainer", locationId: MF },
  { id: 20, label: "Dixon Handle", locationId: LN },
  { id: 21, label: "Dump", locationId: MF },
];

export const filterDipMovementsByLocation = (locationId) => {
  if (!locationId) return DIP_MOVEMENTS;
  const id = Number(locationId);
  return DIP_MOVEMENTS.filter((m) =>
    Array.isArray(m.locationId) ? m.locationId.includes(id) : m.locationId === id,
  );
};
